import { render, staticRenderFns } from "./FlexDataRow.vue?vue&type=template&id=739e04c3&scoped=true"
import script from "./FlexDataRow.vue?vue&type=script&lang=js"
export * from "./FlexDataRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e04c3",
  null
  
)

export default component.exports